const state = {
  strWebSiteId: '9f510a4e30dd4f57a24687a2848329be'
}

export default state
